var map = {
	"./MITAOE-logo.png": 5026,
	"./Oracle_Logo.jpg": 8145,
	"./WorqHatRegisterlogo.png": 1288,
	"./address_image.svg": 599,
	"./animated_logo.svg": 7733,
	"./aws.png": 3771,
	"./azure.png": 4151,
	"./blogs_image.svg": 2885,
	"./certi.png": 3699,
	"./cloud_infrastructure.svg": 7957,
	"./codeInLogo.png": 7935,
	"./contactMail.png": 9581,
	"./coursera_logo.png": 1877,
	"./data_science.svg": 8938,
	"./deeplearning_ai_logo.png": 2862,
	"./desc.PNG": 4350,
	"./developerActivity.svg": 6715,
	"./dpu.png": 8827,
	"./dsc_logo.png": 6390,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./feelingProud.svg": 658,
	"./freecopy_logo.png": 9273,
	"./fullstack.svg": 2043,
	"./gcp_logo.png": 1513,
	"./github_logo.png": 9551,
	"./googleAssistant.jpg": 700,
	"./googleAssistant.svg": 3564,
	"./google_logo.png": 5927,
	"./ibm_logo.png": 9561,
	"./jsFramework.svg": 8446,
	"./legato_logo.png": 5112,
	"./manOnTable.svg": 3034,
	"./microsoft_logo.png": 7231,
	"./mitaoe.png": 5493,
	"./mitaoe_e.png": 2230,
	"./mozilla_logo.png": 9592,
	"./muffito_logo.png": 2295,
	"./nextuLogo.jpg": 1631,
	"./nptel_logo.png": 8936,
	"./oracle.png": 447,
	"./pixelstat.png": 1512,
	"./programmer.svg": 9220,
	"./projects_image.svg": 4716,
	"./pwa.png": 7758,
	"./saayaHealthLogo.png": 6006,
	"./sanket_nangare.jpg": 2121,
	"./sanket_nangare.png": 6589,
	"./spark.png": 3409,
	"./stanford_logo.png": 7137,
	"./stripto.png": 4122,
	"./talksCardBack.svg": 5331,
	"./talksCardBackAlt.svg": 7945,
	"./ui_ux_design.svg": 2337,
	"./uinsports.png": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;